export const line = {
    label: {
        visible: !1,
        position: "top",
        offset: 5,
        style: {
            lineWidth: 2,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    },
    point: {
        style: {
            symbolType: "circle"
        }
    }
};
//# sourceMappingURL=line.js.map
